<template>
  <div id="home">
    <banner/>
    <video-list
        :hot-video="true"
        :index-video="true"
        :auto-load="true"
    />

  </div>
</template>

<script>

export default {
  name: 'Home',

  components: {
    VideoList: () => import('@/components/video/VideoList'),
    Banner: () => import('@/components/home/Banner'),
  },
  data() {
    return {}
  }, methods: {},
  created() {

  }
}
</script>
